import React from "react";
import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "../context/AuthContext";
import { QueryClient, QueryClientProvider } from "react-query";
import ProgressLine from "../components/ProgressLine";
import { ErrorBoundary } from 'react-error-boundary';
import { privateRoutes } from "../const/menu";

import RouteProtected from "./routeProtected";
import Fallback from "../components/ErrorBoundary";

const Dashboard = React.lazy(() => import("../pages/dashboard"));
const Login = React.lazy(() => import("../pages/auth"));
const Layout = React.lazy(() => import("../components/Layout"));
const Page404 = React.lazy(() => import("../pages/page404"));
const Unauthorized = React.lazy(() => import("../pages/unauthorized"));

export default function Router() {
  const queryClient = new QueryClient();

  return (
    <React.Suspense fallback={<ProgressLine />}>
      <QueryClientProvider client={queryClient}>
        <ErrorBoundary FallbackComponent={Fallback}>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route element={<Layout />}>
                <Route path="/admin" element={<Dashboard />} />
                {privateRoutes.map((route, key) => (
                  <Route
                    key={key}
                    element={
                      <RouteProtected allwedPermissions={route.permissions} />
                    }
                  >

                    <Route path={route.path}>
                      <Route index element={<route.component />} />
                      {route.children.length > 0 && getRoutes(route.children)}
                    </Route>
                  </Route>
                ))}
                <Route path="/unauthorized" element={<Unauthorized />} />
              </Route>
              <Route path="*" element={<Page404 />} />
            </Routes>
          </AuthProvider>
        </ErrorBoundary>
      </QueryClientProvider>
    </React.Suspense>
  );
}

const getRoutes = (treeItems) => {
  return treeItems.map((treeItemData, key) => {
    let children = undefined;
    if (treeItemData.children && treeItemData.children.length > 0) {
      children = getRoutes(treeItemData.children);
    }
    return (
      <Route path={treeItemData.path} key={key}>
        <Route
          element={
            <RouteProtected allwedPermissions={treeItemData.permissions} />
          }
        >
          <Route index element={<treeItemData.component />} />
          {children}
        </Route>
      </Route>
    );
  });
};
